import { Component } from '@angular/core';
import { ApplicationActions } from '../../actions/application.actions';
import { FlowManagerService } from '../../shared/services/flowmanager.service';

@Component({
  selector: 'ns-form-account-type-header',
  template: require('./formAccountTypeHeader.component.html')
})
export class FormAccountTypeHeaderComponent {

  constructor(
    appActions: ApplicationActions,
    flowManager: FlowManagerService) {
    this.flowManager = flowManager;
    this.appActions = appActions;
  }

  ngOnInit() {
    this.appType = this.flowManager.getAppType();
    this.appTitle = (this.appType === 'tka')
      ? 'Ally Invest Robo Portfolio Account'
      : 'Self-Directed Trading Account';
    this.investAccount = this.appActions.getData('DepositFunds.to');
  }
}
